var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalDataset = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 1.5H1.5C0.671573 1.5 0 2.17157 0 3V21C0 21.8284 0.671573 22.5 1.5 22.5H10.5V21H1.5V3H22.5V10.5H24V3C24 2.17157 23.3284 1.5 22.5 1.5ZM3 6H21V7.5H3V6ZM21 9H3V19.5H10.5V18H9V16.5H13.5V15H9V13.5H13.5V12H9V10.5H21V9ZM4.5 12H7.5V10.5H4.5V12ZM7.5 15H4.5V13.5H7.5V15ZM4.5 18H7.5V16.5H4.5V18ZM24 21V13.5H16.5V15H21.4395L13.719 22.719L14.781 23.781L22.5 16.0605V21H24Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalDataset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-dataset.d1807d1030f0e9a635a3fc63578fa73c.svg";